export function RedPacketOpenModal({
  open,
  selectedIndex,
  variant = "newbie-step6",
  message = "紅包開啟動畫預覽中..."
}: {
  open: boolean;
  selectedIndex: number | null;
  variant?: "newbie-step6" | "standard";
  message?: string;
}) {
  if (!open) return null;

  return (
    <div className="game-modal-backdrop rg-redpacket-modal-backdrop">
      <section className="game-modal rg-redpacket-modal" data-variant={variant} aria-live="polite">
        <div className="rg-redpacket-opening-stage">
          <div className="rg-redpacket-opening-ring" aria-hidden="true" />
          <div className="rg-redpacket-opening-envelope" aria-hidden="true">
            <span>福</span>
          </div>
        </div>
        <h2>紅包開啟中</h2>
        <div className="modal-body">
          <p>{message}</p>
          {selectedIndex !== null ? <p>已選擇第 {selectedIndex + 1} 個紅包，其他紅包已鎖定。</p> : null}
        </div>
      </section>
    </div>
  );
}
